<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>{{moduleName}} Excel Upload Status</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row m-0 eip-pt-20">
      <div class="col">
          <span class="label label-primary">Total Processed : {{total}}</span>
      </div>
      <div class="col">
          <span class="label label-success">Success : {{success}}</span>
      </div>
      <div class="col">
          <span class="label label-danger">Failure : {{failure}}</span>
      </div>
  </div>
  <div class="row m-0 eip-pt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
      <div class="col">
          <kendo-grid [kendoGridBinding]="statusList" [sortable]="false" [resizable]="true" [reorderable]="true" [pageSize]="15" [filterable]="false" [pageable]="true" id="grvStatusList">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                  <div class="k-grid-toolbar-content d-flex">
                      <div class="flex-grow-1 mat-panel-headerbar"></div>
                      <div class="pagination-container">
                          <p id="lblShowDetails">Show</p>
                          <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                          </kendo-pager-page-sizes>
                          <span>Items</span>
                      </div>
                      <div class="divider-container d-none d-md-block" id="imgDivider">
                          <span></span>
                      </div>
                      <div class="icons-container">
                          <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                          <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                              <div class="icon-wrap">
                                  <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}" (click)="toggleFullscreen()"></i>
                                  <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      {{rowIndex+1}}
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Row No" field="rowNo" [width]="60" filterable="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.rowNo}}" eipTooltipPosition="auto">{{dataItem.rowNo}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Sheet Name" field="sheetName" [width]="100" [hidden]="moduleName.indexOf('Engineering') == -1">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.sheetName}}" eipTooltipPosition="auto">{{dataItem.sheetName}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Name" field="name" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.name}}" eipTooltipPosition="auto">{{dataItem.name}}</span>
                </ng-template>
              </kendo-grid-column>
              <ng-template kendoGridDetailTemplate let-dataItem filterable="false" [kendoGridDetailTemplateShowIf]="showOnlyFailureDetails">
                  <div *ngIf="dataItem.errors">
                      <header><strong>Status</strong></header>
                      <span [ngClass]="{'txt-success' : dataItem.status,'txt-danger' : !dataItem.status }" *ngFor="let error of dataItem.errors">
                          <ul>
                              <li>
                                  {{error}}
                              </li>
                          </ul>
                      </span>
                  </div>
              </ng-template>
              <kendo-grid-column field="status" title="Status" [width]="50">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span [ngClass]="{'txt-success' : dataItem.status,'txt-danger' : !dataItem.status }" [innerText]="getStatus(dataItem)"></span>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
</div>